var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  className: "menu_svg__lucide menu_svg__lucide-menu"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 12h16M4 6h16M4 18h16"
})));
export { SvgMenu as ReactComponent };
export default __webpack_public_path__ + "0b08a7f42ecc6214278554ab96831fc4.svg";